"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyColumns = copyColumns;
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _buttonControl = _interopRequireDefault(require("../../../preact-components/button-control"));

var _assets = _interopRequireDefault(require("../../../preact-components/assets"));

var _SelectColumnsModal = _interopRequireDefault(require("./SelectColumnsModal"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function copyColumns(columns) {
  return columns.map(function (column) {
    return _objectSpread({}, column);
  });
}

var OverviewColumns = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(OverviewColumns, _Component);

  var _super = _createSuper(OverviewColumns);

  function OverviewColumns(props) {
    var _this;

    (0, _classCallCheck2.default)(this, OverviewColumns);
    _this = _super.call(this, props);
    _this.state = {
      columns: copyColumns(props.selectedColumns),
      showSelectColumnsModal: false
    };
    _this.toggleColumn = _this.toggleColumn.bind((0, _assertThisInitialized2.default)(_this));
    _this.onApply = _this.onApply.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClose = _this.onClose.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetToDefault = _this.onResetToDefault.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(OverviewColumns, [{
    key: "onApply",
    value: function onApply() {
      this.props.applySelectedColumns(this.state.columns);
      this.setState({
        showSelectColumnsModal: false
      });
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.setState({
        showSelectColumnsModal: false,
        columns: copyColumns(this.props.selectedColumns)
      });
    }
  }, {
    key: "onResetToDefault",
    value: function onResetToDefault() {
      this.setState({
        columns: copyColumns(this.props.defaultColumns)
      });
    }
  }, {
    key: "toggleColumn",
    value: function toggleColumn(accessor, checked) {
      var columns = this.state.columns;
      var changedColumn = columns.find(function (column) {
        return column.accessor === accessor;
      });
      if (changedColumn) changedColumn.isHidden = !checked;
      columns.map(function (column) {
        return column.accessor === accessor ? changedColumn : column;
      });
      this.setState({
        columns: columns
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          columns = _this$state.columns,
          showSelectColumnsModal = _this$state.showSelectColumnsModal;
      return (0, _preact.h)("div", {
        className: "overview__columns-container"
      }, (0, _preact.h)(_buttonControl.default, {
        newStyle: true,
        title: (0, _preact.h)("div", null, (0, _preact.h)(_assets.default, {
          icon: "column"
        }), "Columns"),
        size: "medium",
        class: "overview__columns",
        onClick: function onClick() {
          return _this2.setState({
            showSelectColumnsModal: true
          });
        }
      }), (0, _preact.h)(_SelectColumnsModal.default, {
        columns: columns,
        showModal: showSelectColumnsModal,
        onApply: this.onApply,
        onClose: this.onClose,
        onResetToDefault: this.onResetToDefault,
        toggleColumn: this.toggleColumn
      }));
    }
  }]);
  return OverviewColumns;
}(_preact.Component);

var _default = OverviewColumns;
exports.default = _default;